<template>
    <Tooltip :is-teleported="true">
        <template #trigger="tooltipProps">
            <div
                class="rounded-md flex items-center justify-center text-white focus-visible:outline-offset-2 focus-visible:outline-2"
                :class="[
                    {
                        'size-6': props.size === 'Extra-Small',
                        'size-8': props.size === 'Small',
                        'size-10': props.size === 'Base',
                    },
                    colorClasses,
                ]"
                tabindex="0"
                :aria-labelledby="tooltipProps['aria-labelledby'] ? `${tooltipProps['aria-labelledby']}` : undefined"
                :popovertarget="tooltipProps['popovertarget'] ? tooltipProps.popovertarget : undefined"
            >
                <StarFilledIcon
                    :class="{
                        'size-4 relative -top-[0.5px]': props.size === 'Extra-Small',
                        'size-5 relative -top-[0.75px]': props.size === 'Small',
                        'size-6 relative -top-px': props.size === 'Base',
                    }"
                />
            </div>
        </template>

        <template #text>
            {{ $t('main-variant') }}
        </template>
    </Tooltip>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import StarFilledIcon from '../Icon/StarFilledIcon.vue';
import { PhaseColor } from '../Timeline/Timeline.types.ts';
import Tooltip from '../Tooltip/Tooltip.vue';

type MainVariantIndicatorProps = {
    size: 'Extra-Small' | 'Small' | 'Base'; // Extra-Small = 24px height, Small = 32px height, Base = 40px height
    color: Extract<
        PhaseColor,
        | 'External-Event-Category-Project'
        | 'External-Event-Category-Event'
        | 'External-Event-Category-External-Event'
        | 'Project'
        | 'Event'
    >;
};

const props = defineProps<MainVariantIndicatorProps>();

const colorClasses = computed(() => {
    switch (props.color) {
        case 'Event':
        case 'External-Event-Category-Event':
            return `focus-visible:outline-sky-700 bg-sky-700`;
        case 'Project':
        case 'External-Event-Category-Project':
            return `focus-visible:outline-rose-700 bg-rose-700`;
        case 'External-Event-Category-External-Event':
            return 'focus-visible:outline-green-700 bg-green-700';
    }
});
</script>
